import React, { useEffect, useState } from 'react';
import { useNuPlayerContext } from '../nu-player/NuPlayerContext';
import { useNuStreamerContext } from '../nu-streamer/NuStreamerContext';

/**
 * Listens for media toggles to stop the music when video starts, or vice versa.
 * Must be used with both streamer and player wrappers
 * @returns {null}
 * @constructor
 */
const NuMediaListener = () => {
  const { isPlaying: isPlayingMusic, stopTheMusic } = useNuPlayerContext();
  const { isPlayingVideo, stopVideoPlayer } = useNuStreamerContext();

  useEffect(() => {
    if (isPlayingMusic && isPlayingVideo) {
      stopVideoPlayer();
    }
  }, [isPlayingMusic]);

  useEffect(() => {
    if (isPlayingMusic && isPlayingVideo) {
      stopTheMusic();
    }
  }, [isPlayingVideo]);

  return null;
};

export default NuMediaListener;
